/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Cors_FallbackInputs */

const en_jobs_cors_fallback = /** @type {(inputs: Jobs_Cors_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not auto-fetch this page (CORS restriction). Please paste the job description below.`)
};

const de_jobs_cors_fallback = /** @type {(inputs: Jobs_Cors_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Seite konnte nicht automatisch abgerufen werden (CORS-Einschränkung). Bitte füge die Stellenbeschreibung unten ein.`)
};

const fr_jobs_cors_fallback = /** @type {(inputs: Jobs_Cors_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de récupérer automatiquement cette page (restriction CORS). Colle la description du poste ci-dessous.`)
};

const es_jobs_cors_fallback = /** @type {(inputs: Jobs_Cors_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo obtener automáticamente esta página (restricción CORS). Por favor, pegue la descripción del puesto a continuación.`)
};

const it_jobs_cors_fallback = /** @type {(inputs: Jobs_Cors_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile recuperare automaticamente questa pagina (restrizione CORS). Incolla la descrizione del lavoro qui sotto.`)
};

const nl_jobs_cors_fallback = /** @type {(inputs: Jobs_Cors_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kon deze pagina niet automatisch ophalen (CORS-beperking). Plak de vacaturetekst hieronder.`)
};

const pl_jobs_cors_fallback = /** @type {(inputs: Jobs_Cors_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie udało się automatycznie pobrać tej strony (ograniczenie CORS). Wklej opis stanowiska poniżej.`)
};

const fi_jobs_cors_fallback = /** @type {(inputs: Jobs_Cors_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sivua ei voitu hakea automaattisesti (CORS-rajoitus). Liitä työpaikkakuvaus alla.`)
};

const da_jobs_cors_fallback = /** @type {(inputs: Jobs_Cors_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunne ikke auto-hente denne side (CORS-begrænsning). Indsæt jobbeskrivelsen nedenfor.`)
};

const sv_jobs_cors_fallback = /** @type {(inputs: Jobs_Cors_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunde inte hämta sidan automatiskt (CORS-begränsning). Klistra in jobbbeskrivningen nedan.`)
};

/**
* | output |
* | --- |
* | "Could not auto-fetch this page (CORS restriction). Please paste the job description below." |
*
* @param {Jobs_Cors_FallbackInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_cors_fallback = /** @type {((inputs?: Jobs_Cors_FallbackInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Cors_FallbackInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_cors_fallback(inputs)
	if (locale === "fr") return fr_jobs_cors_fallback(inputs)
	if (locale === "es") return es_jobs_cors_fallback(inputs)
	if (locale === "it") return it_jobs_cors_fallback(inputs)
	if (locale === "nl") return nl_jobs_cors_fallback(inputs)
	if (locale === "pl") return pl_jobs_cors_fallback(inputs)
	if (locale === "fi") return fi_jobs_cors_fallback(inputs)
	if (locale === "da") return da_jobs_cors_fallback(inputs)
	if (locale === "sv") return sv_jobs_cors_fallback(inputs)
	return en_jobs_cors_fallback(inputs)
});